import { axiosInstance } from "../../../config/api/Axios";

export const getCountriesApi = async (params) => axiosInstance.get("/common/countries", { params });
export const getCitiesApi = async (params) => axiosInstance.get("/common/cities", { params });
export const getDefaultCitiesApi = async (params) => axiosInstance.get("/common/default-cities", { params });
